export enum SarMatrixCellView {
  Circles = 'Circles',
  PieChart = 'PieChart',
  FactorsAbsolute = 'FactorsAbsolute',
}
